import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'

import { environment } from '@environments/environment'

@Injectable({
  providedIn: 'root',
})
export class ElasticApi {
  private readonly http = inject(HttpClient)
  private readonly baseUrl = 'es-archive-documents'

  getFacet (facetName: string, params: any) {
    // limit is set to 1 because setting to 0 disables the limit, and we don't want that data :|
    if (!params) params = {}
    params = { facet: facetName, limit: 1, ...params }
    return this.http.get<any>(`${environment.apiRoot}/api/${this.baseUrl}/`, { params: params })
  }

  list (params: any) {
    if (!params) params = {}
    params = { limit: 500, ...params }
    return this.http.get<any>(`${environment.apiRoot}/api/${this.baseUrl}/`, { params: params })
  }
}
